import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export default function PageHero({ eyebrow, title, lede, breadcrumb = [] }) {
  return (
    <section className="relative overflow-hidden bg-[#07110C] pb-20 pt-20 text-white sm:pb-28 sm:pt-28">
      <div className="absolute inset-0 xpert-grid opacity-50" />
      <div className="absolute -right-24 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full border-[70px] border-[#C8FF4D]/[0.06]" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <motion.nav
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="mb-12 flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[10px] uppercase tracking-[0.22em] text-white/35"
          data-testid="page-breadcrumb"
        >
          <Link to="/" className="transition-colors hover:text-[#C8FF4D]">Home</Link>
          {breadcrumb.map((b, i) => (
            <React.Fragment key={i}>
              <ChevronRight className="w-3 h-3" />
              {b.path ? (
                <Link to={b.path} className="transition-colors hover:text-[#C8FF4D]">
                  {b.label}
                </Link>
              ) : (
                <span className="text-[#C8FF4D]">{b.label}</span>
              )}
            </React.Fragment>
          ))}
        </motion.nav>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid max-w-6xl gap-8 lg:grid-cols-[1fr_.45fr] lg:items-end"
        >
          <div>
            {eyebrow && (
              <div className="mb-6 flex items-center gap-3">
                <span className="h-2 w-2 rounded-full bg-[#C8FF4D]" />
                <span className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-[#C8FF4D]">
                  {eyebrow}
                </span>
              </div>
            )}
            <h1
              data-testid="page-title"
              className="font-display text-4xl font-bold leading-[.98] tracking-[-.055em] text-white sm:text-6xl lg:text-7xl"
            >
              {title}
            </h1>
          </div>
          {lede && (
            <div className="border-l border-[#C8FF4D]/35 pl-6">
              <p className="text-sm leading-relaxed text-white/52 sm:text-base">
                {lede}
              </p>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
